import React from "react";
import AnimatedSection from "@/components/ui/AnimatedSection";

const SERVICES = [
  {
    number: "01",
    title: "Web Development",
    description:
      "Custom websites and web apps built with React, TypeScript, and Node.js — fast, accessible, and production-ready.",
  },
  {
    number: "02",
    title: "Shopify",
    description:
      "Shopify storefronts, themes, and apps designed to look sharp and convert more of the traffic you already have.",
  },
  {
    number: "03",
    title: "Wix App Development",
    description:
      "Wix App Market products from concept to publish, including dashboards, widgets, and merchant-facing tools.",
  },
  {
    number: "04",
    title: "Automation",
    description:
      "n8n, Zapier, Make, and custom workflows that remove repetitive work and keep your systems in sync.",
  },
  {
    number: "05",
    title: "Chrome Extension",
    description:
      "Manifest V3 Chrome extensions, from privacy-first utilities to Chrome Web Store listings that ship.",
  },
  {
    number: "06",
    title: "npm Packages",
    description:
      "Reusable libraries and developer tools published as npm packages, documented and ready to install.",
  },
  {
    number: "07",
    title: "Website Maintenance",
    description:
      "Ongoing updates, performance tuning, bug fixes, and reliability so your site stays healthy after launch.",
  },
  {
    number: "08",
    title: "3D Animated Sites",
    description:
      "Immersive Three.js and WebGL experiences — 3D scenes, motion, and interactive sites that feel alive.",
  },
];

const Services: React.FC = () => {
  return (
    <AnimatedSection>
      <section id="services" className="py-24">
        <div className="flex flex-wrap items-start justify-between gap-8 mb-16">
          <h2
            className="uppercase text-[#e4e4e4] leading-none tracking-tight m-0"
            style={{
              fontFamily: "'League Gothic', sans-serif",
              fontSize: "clamp(3rem, 9vw, 9rem)",
            }}
          >
            Services
            <br />
            I Provide
          </h2>
          <p className="text-[#888] text-sm leading-relaxed max-w-[240px] self-end">
            What I build and ship for clients — from storefronts and extensions
            to automation and 3D web experiences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2">
          {SERVICES.map((service) => (
            <article
              key={service.number}
              className="group border-t border-white/10 px-0 py-8 md:px-6 md:py-10
                         md:odd:pl-0 md:even:pr-0 hover:bg-white/[0.02] transition-colors duration-300"
            >
              <p className="text-white/30 text-[10px] uppercase tracking-[0.3em] mb-4 font-mono">
                {service.number}
              </p>
              <h3
                className="uppercase text-[#e4e4e4] leading-none tracking-tight mb-4 group-hover:text-white transition-colors"
                style={{
                  fontFamily: "'League Gothic', sans-serif",
                  fontSize: "clamp(1.8rem, 4vw, 2.8rem)",
                }}
              >
                {service.title}
              </h3>
              <p className="text-[#888] text-sm md:text-base leading-relaxed max-w-md">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </section>
    </AnimatedSection>
  );
};

export default Services;
